import { Component, EventEmitter, Input, Output } from '@angular/core';
import { StringAttributeFilter } from 'app/shared/ui/models/string-attribute-filter';

@Component({
  selector: 'jhi-string-filter',
  templateUrl: './string-filter.component.html',
  styleUrls: ['./string-filter.component.scss'],
})
export class StringFilterComponent {
  @Input() filter!: StringAttributeFilter;
  @Output() filterChange = new EventEmitter<StringAttributeFilter>();
}
